module.exports = __webpack_public_path__ + "static/media/services_bodyCare2.c1320921.jpg";